import {defineStore} from "pinia";
import LaravelPiniaPlugin from "@/utils/LaravelPiniaPlugin.js";


const options = {
  ...LaravelPiniaPlugin()
};
export const useWishList = defineStore('wishlist', {
  state: () => ({
    ...options.state,
    ...{
      url: '/api/v1/my-wish',
      primaryKey: 'wi_id',
      query: {
        page: 1,
        per_page: 5,
        sort: 'wi_id',
        order: 'desc'
      }
    }
  }),
  getters: {
    ...options.getters,
  },
  actions: {
    ...options.actions,
  }
});
